<template>
  <div
    class="gallery-wrapper"
    :class="{ 'gallery-wrapper-reduced': galleryWrapperReduced }"
  >
    <!-- Multi Client Component -->
    <gallery-grid
      v-if="imagesArr.length"
      :light-box-ready="lightBoxReady"
      :images-arr="imagesArr"
      :object-number="objectData.objectNumber"
      @open-gallery="openGallery"
    />
  </div>
</template>
<script>
/** ************************
 * Multi Client Component
 * Variant: clients/atraveo.de
 * *************************
 */

/** Components */
import GalleryGrid from 'components/GalleryGrid.vue';

export default {
  name: 'ImageGalleryGrid',
  components: {
    GalleryGrid,
  },
  props: {
    showSliderCustom: {
      required: true,
      type: Boolean,
    },
    imagesArr: {
      type: Array,
      default: () => [],
    },
    objectData: {
      type: Object,
      default: () => {},
    },

  },
  data() {
    return {
      lightBoxReady: false,
    };
  },
  computed: {
    // lower gallery height for less than 8 images
    galleryWrapperReduced() {
      return this.imagesArr.length < 8 && this.imagesArr.length > 3;
    },
  },
  mounted() {
    this.lightBoxReady = true;
  },
  methods: {
    openGallery(indexParam) {
      this.$emit('open-gallery', indexParam);
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-wrapper-deactivated {
  @media #{$media_xs} {
    padding-top: 62vw;
  }

  @media #{$media_sm_min} {
    padding-top: 330px;
    &.gallery-wrapper-reduced {
      padding-top: 260px;
    }
  }

  @media #{$media_md_min} {
    padding-top: 450px;
    &.gallery-wrapper-reduced {
      padding-top: 360px;
    }
  }

  @media #{$media_lg_min} {
    padding-top: 410px;
    &.gallery-wrapper-reduced {
      padding-top: 330px;
    }
  }

  @media #{$media_xl_min} {
    padding-top: 500px;
    &.gallery-wrapper-reduced {
      padding-top: 400px;
    }
  }

  @media #{$media_xxl} {
    padding-top: 610px;
    height: 610px;
    overflow:hidden;
    &.gallery-wrapper-reduced {
      padding-top: 490px;
      height: 490px;
    }
  }
}

/deep/ .gallery-grid-container {
  top: 0;
  width: 100%;
  height:100%;
  overflow:hidden;

  ul.gallery-grid {
    align-items: stretch;
    > li:first-child,
    > li:nth-child(2),
    > li:nth-child(3),
    > li:last-child {
      align-self: stretch;
    }

    > li:nth-child(2) img,
    > li:nth-child(3) img {
      /*width:auto;*/
      height:100%;
      @media #{$media_sm_min} {
        height: 120px;
      }

      @media #{$media_md_min} {
        height: 170px;
      }

      @media #{$media_lg_min} {
        height: 155px;
      }

      @media #{$media_xl_min} {
        height: 190px;
      }

      @media #{$media_xxl} {
        height: 235px;
      }
    }
  }
}
</style>
